import React from 'react';
import { cn } from './cn';

/**
 * IconButton — square button with just an icon. Three sizes match the
 * prototype: xs (24px) inside table rows, sm (28px) for inline row actions,
 * md (32px) for toolbar actions.
 *
 *   <IconButton size="sm" aria-label="Edit"><EditIcon/></IconButton>
 */
const SIZE = {
  xs: 'w-6 h-6',
  sm: 'w-7 h-7',
  md: 'w-8 h-8',
  lg: 'w-9 h-9',
};

export function IconButton({
  size = 'md',
  variant = 'default', // default | danger | primary | ghost
  className,
  children,
  type = 'button',
  ...rest
}) {
  const variantClass = {
    default: 'text-text-muted bg-transparent border-transparent hover:bg-cream hover:text-navy hover:border-sand',
    danger:  'text-text-muted bg-transparent border-transparent hover:bg-coral-soft hover:text-coral-dark hover:border-coral',
    primary: 'text-teal-green-dark bg-teal-green-soft border-transparent hover:bg-teal-green hover:text-white',
    ghost:   'text-text-muted bg-transparent border-sand hover:bg-cream hover:text-navy',
  }[variant];

  return (
    <button
      type={type}
      className={cn(
        'inline-grid place-items-center rounded-md border',
        'transition-colors duration-150',
        SIZE[size],
        variantClass,
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}

export default IconButton;
